
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.68.02C7.054.199 4.681 1.3 2.874 3.179 1.265 4.851.287 6.961.038 9.298c-.05.479-.05 1.527 0 2.027.18 1.77.836 3.535 1.83 4.92.538.752 1.334 1.602 1.98 2.116 2.871 2.285 6.662 2.893 10.084 1.62a10.14 10.14 0 002.568-1.41c.19-.14.357-.255.373-.255.015 0 1.05 1.02 2.3 2.266 2.019 2.011 2.293 2.274 2.452 2.34a.996.996 0 001.374-.908c0-.434.102-.314-2.418-2.839-1.247-1.25-2.267-2.284-2.267-2.3 0-.016.1-.162.223-.324a10.372 10.372 0 002.05-5.21c.051-.479.052-1.527.001-2.027a10.518 10.518 0 00-1.058-3.637 9.791 9.791 0 00-1.914-2.626 9.997 9.997 0 00-2.288-1.75C13.664.366 11.57-.108 9.68.02zm1.836 2.04a8.252 8.252 0 014.616 2.285c1.404 1.37 2.205 2.98 2.478 4.985.062.455.053 1.613-.016 2.092a8.404 8.404 0 01-1.598 3.9c-.33.445-1.206 1.33-1.639 1.654-1.201.901-2.495 1.423-4.054 1.636-.455.062-1.613.053-2.093-.017-1.836-.264-3.417-1.036-4.715-2.302-1.405-1.37-2.205-2.98-2.479-4.984-.062-.455-.053-1.613.017-2.093.265-1.835 1.037-3.415 2.303-4.712 1.48-1.516 3.234-2.328 5.442-2.519.325-.028 1.334.016 1.738.076z"}})])
          )
        }
      }
    